import React, { useEffect } from 'react'
import AdminLayout from './adminLayout/AdminLayout'


const AdminDashboard = () => {
  return (
    <div>
      <AdminLayout/>
    </div>
  )
}

export default AdminDashboard
